<template>
  <div v-if="checked">
    <div class="flex items-center gap-1 text-xs">
      <TIcon name="check" class="text-success-500" />
      <span>
        <slot name="checked" />
      </span>
    </div>
  </div>
  <div v-else>
    <div class="flex items-center gap-1 text-xs">
      <TIcon name="close" size="16" class="text-danger-500" />
      <span>
        <slot name="unchecked" />
      </span>
    </div>
  </div>
</template>
<script setup lang="ts">
import TIcon from './Icon/TIcon.vue';
defineProps<{ checked: boolean }>();
</script>
